import { render, staticRenderFns } from "./PersonalChatEditor.vue?vue&type=template&id=ca65cd60&scoped=true&"
import script from "./PersonalChatEditor.vue?vue&type=script&lang=js&"
export * from "./PersonalChatEditor.vue?vue&type=script&lang=js&"
import style0 from "./PersonalChatEditor.vue?vue&type=style&index=0&id=ca65cd60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca65cd60",
  null
  
)

export default component.exports